import type { IconName } from "@iec-id/ui";

/**
 * Разделы витрины (макет 2a, левое меню). Порядок и состав фиксированы:
 * это не «пункты меню», а карта личного кабинета — сервисы ссылаются на них
 * напрямую (`id.iec.exchange/security`), поэтому пути менять нельзя.
 *
 * Роуты соседних разделов пишут другие агенты; ссылки на них живут здесь
 * с первого дня, иначе шелл пришлось бы переписывать при каждом подключении.
 */
export type NavSection = {
	key: string;
	to: string;
	icon: IconName;
	/** Ключ подписи в namespace `common`. */
	labelKey: string;
};

export const NAV_SECTIONS = [
	{ key: "overview", to: "/", icon: "Home", labelKey: "nav.overview" },
	{ key: "personal", to: "/personal", icon: "UserRound", labelKey: "nav.personal" },
	{ key: "security", to: "/security", icon: "ShieldCheck", labelKey: "nav.security" },
	{ key: "points", to: "/points", icon: "Coins", labelKey: "nav.points" },
	{ key: "plus", to: "/plus", icon: "Sparkles", labelKey: "nav.plus" },
	{ key: "services", to: "/services", icon: "LayoutGrid", labelKey: "nav.services" },
	{ key: "legal", to: "/legal", icon: "Scroll", labelKey: "nav.legal" },
] as const satisfies readonly NavSection[];

/** Лента уведомлений в левом меню не живёт: в неё ведёт колокольчик шапки. */
export const NOTIFICATIONS_SECTION = {
	key: "notifications",
	to: "/notifications",
	icon: "Bell",
	labelKey: "nav.notifications",
} as const satisfies NavSection;

export type SectionPath = (typeof NAV_SECTIONS)[number]["to"] | typeof NOTIFICATIONS_SECTION.to;
